import { QuestionDayTripPlanIsRequest as Question } from "@/components/features/items/edit/plan/_shared/ui/components/plan-attributes/is-request";

import { useDayTripPlanIsRequest } from "./hooks";

export const QuestionDayTripPlanIsRequest = () => {
	const { isRequest, onSetIsRequest } = useDayTripPlanIsRequest();

	return <Question isRequest={isRequest} onSetIsRequest={onSetIsRequest} />;
};

QuestionDayTripPlanIsRequest.displayName = "QuestionDayTripPlanIsRequest";
